import React from "react"
import { CloseIcon } from "components/SvgIcons"
import { useTrackElementClicked } from "packages/membership/tracking"
import type { SlideId } from "types"
import { headerTitle, headerWrapper } from "../DiscoveryJourneyModal.css"
import { baseTrackingValues } from "../types"
import { colours } from "@shared/ui.design-system"

type Props = {
  handleCloseModal: () => void
  slideId: SlideId
}

const transformSlideLocation = (slideId: SlideId) => {
  switch (slideId) {
    case "ACTIVE_BENEFITS":
      return "active_benefits_slide"
    case "NO_ACTIVE_MEMBERSHIP":
      return "no_active_membership_slide"
    case "REDEEMED_BENEFITS":
      return "redeemed_benefits_slide"
    case "WELCOME_SLIDE":
      return "welcome_slide"
    default:
      return ""
  }
}

export const Header: React.FC<Props> = ({ handleCloseModal, slideId }) => {
  const { elementClicked } = useTrackElementClicked(baseTrackingValues)

  const onHandleCloseModal = () => {
    elementClicked({
      details: "close_icon",
      locationDetails: transformSlideLocation(slideId),
    })
    handleCloseModal()
  }

  return (
    <div className={headerWrapper}>
      <h3 className={headerTitle}>Your Perks got better!</h3>
      <div>
        <CloseIcon
          cursor="pointer"
          color={colours.primary.dark}
          boxSize="1.5rem"
          aria-label="Close"
          onClick={onHandleCloseModal}
        />
      </div>
    </div>
  )
}
